<div class="participant-card">
  <app-classroom-user-card class="user" [user]="userCard"></app-classroom-user-card>
  <div class="actions">
    <span class="status">{{ statusName(participant.accept_status) | customLocale }}</span>
    <span class="action" (click)="onExclude()">Исключить</span>
  </div>
</div>